if (!window.pajpApp || typeof window.pajpApp == "undefined") {
  window.pajpApp = {};
}

const defaults = {
    "value": 0,
    "stars": 5,
    "half": false,
    "emptyStar": "far fa-star",
    "halfStar": "fas fa-star-half-alt",
    "filledStar": "fas fa-star",
    "color": "#fcd703",
    "readonly": false,
    "click": function (e) {
        console.error("No click callback provided!");
    }
};

$(function () {
    $("[data-rating-stars]").each(function () {
        // Get all data-rating attributes
        let d = {},
            re_dataAttr = /^data-rating\-(.+)$/;

        $.each($(this).get(0).attributes, function (index, attr) {
            if (re_dataAttr.test(attr.nodeName)) {
                let key = attr.nodeName.match(re_dataAttr)[1];
                d[key] = attr.nodeValue;
            }
        });

        // Create the click event handler
        if (d.input != null) {
            d.click = function (e) {
                $(d.input).val(e.stars);
            }
        }

        // Run the rating function on the element
        $(this).rating(d);
    });
});

pajp_docReady(function () {

    jQuery.fn.extend({
      rating: function (options = {}) {
          return this.each(function () {
              if ($(this).attr("rating")) {
                  $(this).empty();
              }

              this.stars = options.value ? options.value : defaults.value;
              this.readonly = options.readonly ? options.readonly : defaults.readonly;

              this.getStars = function () {
                  return $(this).find($("i"));
              };

              $(this).css({
                  "color": options.color ? options.color : defaults.color
              })
                  .attr("rating", true);

              if (!this.readonly) {
                  $(this).off('mousemove').on('mousemove', function (e) {
                      let halfStars = options.half ? options.half : defaults.half;

                      if (this.getStars().index(e.target) >= 0) {
                          if (!halfStars) {
                              $(this).find("i").attr("class", options.emptyStar ? options.emptyStar : defaults.emptyStar);
                              let index = this.getStars().index(e.target) + 1;

                              for (let i = 0; i < this.getStars().length; i++) {
                                  if (i < index)
                                      $(this.getStars()[i]).attr("class", options.filledStar ? options.filledStar : defaults.filledStar)
                              }

                          } else {
                              $(this).find("i").attr("class", options.emptyStar ? options.emptyStar : defaults.emptyStar);
                              let extra = 0.5;

                              $(this).find("i").css({
                                  "width": $(this).find("i").outerWidth()
                              });

                              if (e.offsetX > ($(e.target).outerWidth() / 2))
                                  extra = 1;

                              let index = this.getStars().index(e.target) + extra;
                              for (let i = 0; i < this.getStars().length; i++) {
                                  if (i + 0.5 < index) {
                                      $(this.getStars()[i]).attr("class", options.filledStar ? options.filledStar : defaults.filledStar)
                                  } else if (i < index) {
                                      $(this.getStars()[i]).attr("class", options.halfStar ? options.halfStar : defaults.halfStar)
                                  }
                              }
                          }
                      }
                  });

                  $(this).off('mouseout').on('mouseout', function (e) {
                      this.printStars();
                  });

                  $(this).off('click').on('click', function (e) {
                      let halfStars = options.half ? options.half : defaults.half;
                      if (!halfStars) {
                          this.stars = this.getStars().index(e.target) + 1;
                      } else {
                          let extra = 0.5;
                          if (e.offsetX > ($(e.target).outerWidth() / 2))
                              extra = 1;

                          this.stars = this.getStars().index(e.target) + extra;
                      }

                      const callback = options.click ? options.click : defaults.click;
                      callback({
                          "stars": this.stars,
                          "event": e
                      });
                  });
              }

              // Add star elements to the element
              const stars = options.stars ? options.stars : defaults.stars;
              for (let i = 0; i < stars; i++) {
                  let star = $("<i></i>")
                      .addClass(options.emptyStar ? options.emptyStar : defaults.emptyStar)
                      .appendTo($(this));

                  if (!this.readonly) {
                      star.css({
                          "cursor": "pointer"
                      })
                  }

                  if (i > 1000)
                      return;
              }

              this.printStars = function () {
                  let halfStars = options.half ? options.half : defaults.half;
                  if (!halfStars) {
                      $(this).find("i").attr("class", options.emptyStar ? options.emptyStar : defaults.emptyStar);
                      for (let i = 0; i < this.stars; i++) {
                          $(this.getStars()[i]).attr("class", options.filledStar ? options.filledStar : defaults.filledStar)
                      }
                  } else {
                      $(this).find("i").attr("class", options.emptyStar ? options.emptyStar : defaults.emptyStar);
                      for (let i = 0; i < this.stars; i++) {
                          if (i < this.stars - 0.5) {
                              $(this.getStars()[i]).attr("class", options.filledStar ? options.filledStar : defaults.filledStar)
                          } else {
                              $(this.getStars()[i]).attr("class", options.halfStar ? options.halfStar : defaults.halfStar)
                          }
                      }
                  }
              };

              if (this.stars > 0) {
                  this.printStars();

                  const callback = options.click ? options.click : defaults.click;
                  callback({
                      "stars": this.stars
                  });
              }
          });
      }
  });
  
  window.pajpApp.check_reviews();
  
  

});

window.pajpApp.check_reviews = function(){
  
	  var auto_code_sizes = document.querySelector('#pajp-reviews-automatic-code');
      var product_id = auto_code_sizes.getAttribute("data-pajp-product-id");
      var shop_id = auto_code_sizes.getAttribute("data-pajp-shop-id");
  	  var variant_id = auto_code_sizes.getAttribute("data-pajp-variant-id");
  
  	  //var copied = document.getElementById('pajp-reviews-automatic-code').children[0];
  
      var copied = $('#pajp-reviews-automatic-code .shopify-section');
  
      if(copied.length > 0){
        
  	  	window.pajpApp.copy_reviews_container();
      }
  
      axios.post('https://pajphost.com/customer/public/api/checkReviewsProduct', {
            
            product_id: product_id,
            shop_id: shop_id,
          })
          .then(function(response){
 
            if(response.data.length != 0){
            
              	var customer_logged = $('#last_reviews').attr('data-customerlogged');
              
              	$('#PajpReviewsContainer').show();
              	$('#PajpNoReviews').hide();
              	$('#PajpReviewsContainer .pajp_reviews_avg').text(String(response.data.rating_avg).replace('.', ','));
              	//agregar el starrating
              	var reviews_count_text = response.data.reviews_count;
                if(reviews_count_text == 1){
                  reviews_count_text += " review";
                }else{
                  reviews_count_text += " reviews";
                }
				$('#PajpReviewsContainer .pajp_reviews_count').text(reviews_count_text);
              
              	$('#star_count_5_bar').width(response.data.rating_graph[5]['percent']+"%");
                $('#star_count_4_bar').width(response.data.rating_graph[4]['percent']+"%"); 
                $('#star_count_3_bar').width(response.data.rating_graph[3]['percent']+"%"); 
                $('#star_count_2_bar').width(response.data.rating_graph[2]['percent']+"%"); 
                $('#star_count_1_bar').width(response.data.rating_graph[1]['percent']+"%"); 
              
                $('#star_count_5_percent').text(response.data.rating_graph[5]['percent']+"%");
                $('#star_count_4_percent').text(response.data.rating_graph[4]['percent']+"%"); 
                $('#star_count_3_percent').text(response.data.rating_graph[3]['percent']+"%"); 
                $('#star_count_2_percent').text(response.data.rating_graph[2]['percent']+"%"); 
                $('#star_count_1_percent').text(response.data.rating_graph[1]['percent']+"%"); 

              
              	var new_rating_span = document.createElement('div');
              	new_rating_span.id = "rating-star-new";
              	new_rating_span.style.fontSize = "0.9rem";
            	new_rating_span.style.marginLeft = "10px";

              	$('#PajpReviewsContainer .pajp_reviews_rating').append(new_rating_span);
              
              	$("#rating-star-new").rating({
                  "value": response.data.rating_avg,
                  "color": "#f61",
                  "readonly": true,
                  "half": true

                });
              	$("#rating-star-new").removeAttr("id");
       
              
             	//window.pajpApp.addCLickEventSizeBtn();
              
              
              	//listar los 3 ultimos comentarios
              var reviews_ordered = response.data.reviews.sort(function(a,b){
                // Turn your strings into dates, and then subtract them
                // to get a value that is either negative, positive, or zero.
                return new Date(b.created_at) - new Date(a.created_at);
              });
              
              window.pajpApp.all_reviews = reviews_ordered;
              
              var i = 0;
              var ended = false;
              while(i < 3 && !ended){
                var current_rev = reviews_ordered[i];
                if(current_rev){
                  
                	var new_review = document.createElement('div');
                    new_review.classList.add("card-comment");

                    if(current_rev['customer_pic'] != "empty"){
                      var new_pic = document.createElement('img');
                      new_pic.classList.add("img-circle");
                      new_pic.classList.add("img-sm");
                      new_pic.setAttribute("alt", "User Image");
                      new_pic.setAttribute("src", current_rev['customer_pic']);
                    }else{
                    	var new_pic = document.createElement('p');
                      	new_pic.setAttribute("data-letters", getInitials(current_rev['customer_name']));
                      
                      	var hue = Math.floor(Math.random() * 360);
						var pastel = 'hsl(' + hue + ', 100%, 90%)';
                      	var darker_pastel = 'hsl(' + hue + ', 100%, 55%)';
                      
                      	new_pic.style.background = pastel;
                      	new_pic.style.color = darker_pastel;
                    }

                    var new_comment_text = document.createElement('div');
                    new_comment_text.classList.add("comment-text");

                    var new_username = document.createElement('span');
                    new_username.classList.add("username");
                    new_username.textContent = current_rev['customer_name'];
                  	new_username.setAttribute("review_comment", current_rev['comment']);
                  	new_username.setAttribute("review_rating", current_rev['rating']);
                  	new_username.setAttribute("review_id", current_rev['id']);

                    var new_comment_date = document.createElement('span');
                    new_comment_date.classList.add('text-muted');
                    new_comment_date.classList.add('float-right');
                    new_comment_date.classList.add('comment-date');
                  	//Hacer fecha para menos de 24 horas
                 	var today = new Date();
                  	var date_formatted = moment(current_rev['created_at']).format("MM/DD/YYYY");
                  	var hours = Math.abs(date_formatted - today) / 36e5;
                    if(hours < 1){
						new_comment_date.textContent = "Just now";
                    }else if(hours < 24){
                    	new_comment_date.textContent = Math.trunc(hours)+"h ago";
                    }else{
                    	new_comment_date.textContent = date_formatted;
                    }
                    
                  	//new_comment_date.textContent = hours+" horas. Fue el: "+date_formatted.toLocaleString('en-US');

                    var new_comment_info_1 = document.createElement('div');
                    new_comment_info_1.classList.add("row");
                    new_comment_info_1.style.cssText ="margin-left: 0px; margin-bottom: 10px;";

                    var new_img_country = document.createElement('img');
                    new_img_country.classList.add("country_flag");
                    new_img_country.setAttribute("src", "https://flagcdn.com/"+current_rev['customer_country']+".svg");
                    new_img_country.style.cssText = "border-radius:50%;height: 20px;width: 20px;object-fit: cover; display: block; float: unset;";

                    var new_country_span = document.createElement("span");
                    new_country_span.style.cssText = "margin-left: 7px; margin-top: -2px;";
                    new_country_span.textContent = current_rev['customer_country'].toUpperCase();

                    /*var new_rating_span = document.createElement("span");
                    new_rating_span.classList.add("rating");
                    new_rating_span.setAttribute("data-default-rating", current_rev['rating']);
                    new_rating_span.setAttribute("disabled", "");

                    var r = SimpleStarRating(new_rating_span);*/
                  
                    var new_rating_span = document.createElement('div');
                    new_rating_span.id = "rating-star-new";
                    new_rating_span.classList.add('rating-star');
                  	new_rating_span.classList.add('in-comment-stars');
                  	new_rating_span.style.fontSize = "0.9rem";

                  	//cantidad de estrellas deshabilitado
                    /*var new_rating_value = document.createElement("span");
                    new_rating_value.style.cssText = "margin-left: 2px; margin-top: -2px;";
                    new_rating_value.textContent = current_rev['rating'];*/

                    var new_likes_dislikes_container = document.createElement("span");
                    new_likes_dislikes_container.classList.add("text-muted");
                    new_likes_dislikes_container.classList.add("float-right");
                    new_likes_dislikes_container.classList.add("comment-date");
                  	new_likes_dislikes_container.classList.add("likes-container");
                    //new_likes_dislikes_container.style.cssText = "margin-top: 10px;";
                  	//new_likes_dislikes_container.setAttribute("product_id", current_rev['sizes_product_id']);
                  	new_likes_dislikes_container.setAttribute("review_id", current_rev['id']);

                    var likes_icon = document.createElement("i");
                  	//Comprobar si ya el usuario le dió like viendo las cookies (far es vacio) y (fas es lleno)
                  	var user_liked = getCookie("review_liked_"+current_rev['id']);
                    if(user_liked && user_liked=="like"){
						likes_icon.classList.add("fas");
                    }else{
                    	likes_icon.classList.add("far");
                    }
                    
                    likes_icon.classList.add("fa-thumbs-up");
                    likes_icon.classList.add("left-15");
                    likes_icon.classList.add("color-primary");
                  	likes_icon.addEventListener("click",function(){likeThisProduct(this, "like")}, false);

                    var dislikes_icon = document.createElement("i");
                  	//Comprobar si ya el usuario le dió dislike viendo las cookies
                  	if(user_liked && user_liked=="dislike"){
						dislikes_icon.classList.add("fas");
                    }else{
                    	dislikes_icon.classList.add("far");
                    }
                    
                    dislikes_icon.classList.add("fa-thumbs-down");
                    dislikes_icon.classList.add("left-15");
                    dislikes_icon.classList.add("color-primary");
                  	dislikes_icon.addEventListener("click",function(){likeThisProduct(this, "dislike")}, false);

                    new_likes_dislikes_container.append(likes_icon);
                    new_likes_dislikes_container.append(dislikes_icon);
                    likes_icon.before(current_rev['likes']);


                    new_username.append(new_comment_date);
                    //new_comment_date.before(response['customer_name']);


                    new_comment_info_1.append(new_img_country);
                    new_comment_info_1.append(new_country_span);
                    new_comment_info_1.append(new_rating_span);
                    //new_comment_info_1.append(new_rating_value);


                    new_comment_text.append(new_username);
                    new_comment_text.append(new_comment_info_1);
                    new_comment_text.append(new_likes_dislikes_container);
                    //new_likes_dislikes_container.before(current_rev['comment']);
                   
                  	var paragraph_review = document.createElement('p');
                  	paragraph_review.classList.add('review-paragraph');
                  
                  	var text_truncated = truncate(current_rev['comment'], 55, '...');
                  	paragraph_review.textContent = text_truncated;
                  
					new_likes_dislikes_container.before(paragraph_review);
                    if(text_truncated != current_rev['comment']){
                      	var read_more_link = document.createElement('span');
                      	read_more_link.textContent = "more";
                      	read_more_link.style.cursor = "pointer";
                      	read_more_link.style.marginLeft = "6px";
                      	read_more_link.style.textDecoration= "underline";
                      	read_more_link.setAttribute("review_id", current_rev['id']);
                      	read_more_link.setAttribute("customer_name", current_rev['customer_name']);
                      	read_more_link.setAttribute("customer_pic", current_rev['customer_pic']);
                      	read_more_link.setAttribute("created_at", current_rev['created_at']);
                      	read_more_link.setAttribute("customer_country", current_rev['customer_country']);
                      	read_more_link.setAttribute("review_likes", current_rev['likes']);
                      	read_more_link.setAttribute("review_comment", current_rev['comment']);
                      	read_more_link.setAttribute("review_rating", current_rev['rating']);
                      
                        read_more_link.addEventListener("click", function(){
                          
                          	//buscando atributos del review INICIO
                          	var review_complete_id = this.getAttribute("review_id");
                          	var review_complete_customer_name = this.getAttribute("customer_name");
                          	var review_complete_customer_pic = this.getAttribute("customer_pic");
                          	var review_complete_created_at = this.getAttribute("created_at");
                          	var review_complete_customer_country = this.getAttribute("customer_country");
                          	var review_complete_likes = this.getAttribute("review_likes");
                          	var review_complete_comment = this.getAttribute("review_comment");
                          	var review_complete_rating = this.getAttribute("review_rating");
                          	//buscando atributos del review FIN
                          
                          
                          	var modalSeeMoreReview = document.getElementById("seeMoreReview");
                          	
							modalSeeMoreReview.style.display = "block";
                          
                          	//llenar el modal con la info del review
                          	var modal_body = $(modalSeeMoreReview).find('.modal-body-container');
                          	modal_body.empty();
                          
                          	var new_review = document.createElement('div');
                            new_review.classList.add("card-comment");

                            if(review_complete_customer_pic != "empty"){
                              var new_pic = document.createElement('img');
                              new_pic.classList.add("img-circle");
                              new_pic.classList.add("img-sm");
                              new_pic.setAttribute("alt", "User Image");
                              new_pic.setAttribute("src", review_complete_customer_pic);
                            }else{
                                var new_pic = document.createElement('p');
                                new_pic.setAttribute("data-letters", getInitials(review_complete_customer_name));

                                var hue = Math.floor(Math.random() * 360);
                                var pastel = 'hsl(' + hue + ', 100%, 90%)';
                                var darker_pastel = 'hsl(' + hue + ', 100%, 55%)';

                                new_pic.style.background = pastel;
                                new_pic.style.color = darker_pastel;
                            }

                            var new_comment_text = document.createElement('div');
                            new_comment_text.classList.add("comment-text");

                            var new_username = document.createElement('span');
                            new_username.classList.add("username");
                            new_username.textContent = review_complete_customer_name;

                            var new_comment_date = document.createElement('span');
                            new_comment_date.classList.add('text-muted');
                            new_comment_date.classList.add('float-right');
                            new_comment_date.classList.add('comment-date');
                            /*var date_formatted = new Date(review_complete_created_at);
                            new_comment_date.textContent = date_formatted.toLocaleString('en-US');*/
                          	//Hacer fecha para menos de 24 horas
                            var today = new Date();
                            var date_formatted = moment(review_complete_created_at).format("MM/DD/YYYY");
                            var hours = Math.abs(date_formatted - today) / 36e5;
                            if(hours < 1){
                                new_comment_date.textContent = "Just now";
                            }else if(hours < 24){
                                new_comment_date.textContent = Math.trunc(hours)+"h ago";
                            }else{
                                new_comment_date.textContent = date_formatted;
                            }

                            var new_comment_info_1 = document.createElement('div');
                            new_comment_info_1.classList.add("row");
                            new_comment_info_1.style.cssText ="margin-left: 0px; margin-bottom: 10px;";

                            var new_img_country = document.createElement('img');
                            new_img_country.classList.add("country_flag");
                            new_img_country.setAttribute("src", "https://flagcdn.com/"+review_complete_customer_country+".svg");
                            new_img_country.style.cssText = "border-radius:50%;height: 20px;width: 20px;object-fit: cover; display: block; float: unset;";

                            var new_country_span = document.createElement("span");
                            new_country_span.style.cssText = "margin-left: 7px; margin-top: -2px;";
                            new_country_span.textContent = review_complete_customer_country;

                            var new_rating_span = document.createElement('div');
                            new_rating_span.id = "rating-star-new";
                            new_rating_span.classList.add('rating-star');
                            new_rating_span.classList.add('in-comment-stars');
                            new_rating_span.style.fontSize = "0.9rem";

                            var new_likes_dislikes_container = document.createElement("span");
                            new_likes_dislikes_container.classList.add("text-muted");
                            new_likes_dislikes_container.classList.add("float-right");
                            new_likes_dislikes_container.classList.add("comment-date");
                            new_likes_dislikes_container.classList.add("likes-container");
                            //new_likes_dislikes_container.style.cssText = "margin-top: 10px;";
                            new_likes_dislikes_container.setAttribute("review_id", review_complete_id);

                            var likes_icon = document.createElement("i");
                            //Comprobar si ya el usuario le dió like viendo las cookies (far es vacio) y (fas es lleno)
                            var user_liked = getCookie("review_liked_"+review_complete_id);
                            if(user_liked && user_liked=="like"){
                              likes_icon.classList.add("fas");
                            }else{
                              likes_icon.classList.add("far");
                            }

                            likes_icon.classList.add("fa-thumbs-up");
                            likes_icon.classList.add("left-15");
                            likes_icon.classList.add("color-primary");
                            likes_icon.addEventListener("click",function(){likeThisProductInMore(this, "like")}, false);

                            var dislikes_icon = document.createElement("i");
                            //Comprobar si ya el usuario le dió dislike viendo las cookies
                            if(user_liked && user_liked=="dislike"){
                              dislikes_icon.classList.add("fas");
                            }else{
                              dislikes_icon.classList.add("far");
                            }

                            dislikes_icon.classList.add("fa-thumbs-down");
                            dislikes_icon.classList.add("left-15");
                            dislikes_icon.classList.add("color-primary");
                            dislikes_icon.addEventListener("click",function(){likeThisProductInMore(this, "dislike")}, false);

                            new_likes_dislikes_container.append(likes_icon);
                            new_likes_dislikes_container.append(dislikes_icon);
                          
                          	var like_count = document.createElement('span');
                           	like_count.classList.add('like-count');
                            like_count.textContent = review_complete_likes;
                            
                            likes_icon.before(like_count);


                            new_username.append(new_comment_date);

                            new_comment_info_1.append(new_img_country);
                            new_comment_info_1.append(new_country_span);
                            new_comment_info_1.append(new_rating_span);

                            new_comment_text.append(new_username);
                            new_comment_text.append(new_comment_info_1);
                            new_comment_text.append(new_likes_dislikes_container);
                            //new_likes_dislikes_container.before(current_rev['comment']);
                          
                            var paragraph_review = document.createElement('p');
                            paragraph_review.classList.add('review-paragraph-big');

                            paragraph_review.textContent = review_complete_comment;
                          	new_likes_dislikes_container.before(paragraph_review);

                            new_review.append(new_pic);
                            new_review.append(new_comment_text);              

                            //$('#all_comments_container').append(new_review);
                          	modal_body.append(new_review);

                            $("#rating-star-new").rating({
                              "value": review_complete_rating,
                              "color": "#f61",
                              "readonly": true

                            });
                            $("#rating-star-new").removeAttr("id");
                          }); 

						paragraph_review.append(read_more_link);
                    }
					if(current_rev['customer_id'] == customer_logged){
                      var editButton = document.createElement('button');
                      editButton.classList.add('editButton');
                      editButton.addEventListener("click", function(){
                      	editReview(this);
                      });
                      
                      var editButtonIcon = document.createElement('i');
                      editButtonIcon.classList.add('fas');
                      editButtonIcon.classList.add('fa-pen-square');
                      
                      editButton.append(editButtonIcon);
                      new_review.append(editButton);
                      
                    }
                    new_review.append(new_pic);
                    new_review.append(new_comment_text); 

                    //$('#PajpReviewsContainer .card-comments').append(new_review);
                  	$('#last_reviews').append(new_review);
                  
                  	$("#rating-star-new").rating({
                      "value": current_rev['rating'],
                      "color": "#f61",
                      "readonly": true

                    });
                  	$("#rating-star-new").removeAttr("id");

                    i++;
                }else{
                	ended = true;
                }
                
              }
              
              //console.log(reviews_ordered);
              	
            }else{
            	//hacer el bloque de que no tiene escribe tu el primero
              	$('#PajpReviewsContainer').hide();
              	$('#PajpNoReviews').show();
            }
              
          })
          .catch(function(error){
              console.log(error);
              $('#PajpReviewsContainer').hide();
              $('#PajpReviewsContainer').append("Error");
              $('#PajpNoReviews').show();
          });
};

const truncate = (str, max, suffix) => str.length < max ? str : `${str.substr(0, str.substr(0, max - suffix.length).lastIndexOf(' '))}${suffix}`;

function getInitials(e){
	var names = e.split(' '),
        initials = names[0].substring(0, 1).toUpperCase();
    
    if (names.length > 1) {
        initials += names[names.length - 1].substring(0, 1).toUpperCase();
    }
    return initials;
}

function editReview(e){
	
  	var parent = $(e).parent();
  	var spanInfo = parent.find('span.username');
  
    //buscando atributos del review INICIO
    var review_complete_id = spanInfo.attr("review_id");
    /*var review_complete_customer_name = spanInfo.attr("customer_name");*/
    /*var review_complete_customer_pic = spanInfo.attr("customer_pic");*/
    var review_complete_created_at = spanInfo.attr("created_at");
    var review_complete_customer_country = spanInfo.attr("customer_country");
    var review_complete_likes = spanInfo.attr("review_likes");
    var review_complete_comment = spanInfo.attr("review_comment");
    var review_complete_rating = spanInfo.attr("review_rating");
    //buscando atributos del review FIN
  
  	var modalEditReview = document.getElementById("editReview");
    modalEditReview.style.display = "block";
    $(modalEditReview).find('.rating-star').rating({
      "stars": 5,
      "value": review_complete_rating,
      "color": "#f61",
      "click": function(e){

        $(modalEditReview).find('input[name="rating_edit"]').val(e.stars);
      }
    });
    $(modalEditReview).find('#review_content_edit').text(review_complete_comment);
  	$(modalEditReview).find('#review_id_edit').val(review_complete_id);
  
}

window.pajpApp.fill_all_reviews_modal = function(){
  
  window.pajpApp.all_reviews.forEach(function(current_rev){
  	var new_review = document.createElement('div');
    new_review.classList.add("card-comment");

    if(current_rev['customer_pic'] != "empty"){
      var new_pic = document.createElement('img');
      new_pic.classList.add("img-circle");
      new_pic.classList.add("img-sm");
      new_pic.setAttribute("alt", "User Image");
      new_pic.setAttribute("src", current_rev['customer_pic']);
    }else{
      var new_pic = document.createElement('p');
      new_pic.setAttribute("data-letters", getInitials(current_rev['customer_name']));

      var hue = Math.floor(Math.random() * 360);
      var pastel = 'hsl(' + hue + ', 100%, 90%)';
      var darker_pastel = 'hsl(' + hue + ', 100%, 55%)';

      new_pic.style.background = pastel;
      new_pic.style.color = darker_pastel;
    }

    var new_comment_text = document.createElement('div');
    new_comment_text.classList.add("comment-text");

    var new_username = document.createElement('span');
    new_username.classList.add("username");
    new_username.textContent = current_rev['customer_name'];

    var new_comment_date = document.createElement('span');
    new_comment_date.classList.add('text-muted');
    new_comment_date.classList.add('float-right');
    new_comment_date.classList.add('comment-date');
    /*var date_formatted = new Date(current_rev['created_at']);
    new_comment_date.textContent = date_formatted.toLocaleString('en-US');*/
    //Hacer fecha para menos de 24 horas
    var today = new Date();
    var date_formatted = moment(current_rev['created_at']).format("MM/DD/YYYY");
    var hours = Math.abs(date_formatted - today) / 36e5;
    if(hours < 1){
      new_comment_date.textContent = "Just now";
    }else if(hours < 24){
      new_comment_date.textContent = Math.trunc(hours)+"h ago";
    }else{
      new_comment_date.textContent = date_formatted;
    }

    var new_comment_info_1 = document.createElement('div');
    new_comment_info_1.classList.add("row");
    new_comment_info_1.style.cssText ="margin-left: 0px; margin-bottom: 10px;";

    var new_img_country = document.createElement('img');
    new_img_country.classList.add("country_flag");
    new_img_country.setAttribute("src", "https://flagcdn.com/"+current_rev['customer_country']+".svg");
    new_img_country.style.cssText = "border-radius:50%;height: 20px;width: 20px;object-fit: cover; display: block; float: unset;";

    var new_country_span = document.createElement("span");
    new_country_span.style.cssText = "margin-left: 7px; margin-top: -2px;";
    new_country_span.textContent = current_rev['customer_country'].toUpperCase();

    var new_rating_span = document.createElement('div');
    new_rating_span.id = "rating-star-new";
    new_rating_span.classList.add('rating-star');
    new_rating_span.classList.add('in-comment-stars');
    new_rating_span.style.fontSize = "0.9rem";

    var new_likes_dislikes_container = document.createElement("span");
    new_likes_dislikes_container.classList.add("text-muted");
    new_likes_dislikes_container.classList.add("float-right");
    new_likes_dislikes_container.classList.add("comment-date");
    new_likes_dislikes_container.classList.add("likes-container");
    new_likes_dislikes_container.style.cssText = "margin-top: -28px;";
    new_likes_dislikes_container.setAttribute("review_id", current_rev['id']);

    var likes_icon = document.createElement("i");
    //Comprobar si ya el usuario le dió like viendo las cookies (far es vacio) y (fas es lleno)
    var user_liked = getCookie("review_liked_"+current_rev['id']);
    if(user_liked && user_liked=="like"){
      likes_icon.classList.add("fas");
    }else{
      likes_icon.classList.add("far");
    }

    likes_icon.classList.add("fa-thumbs-up");
    likes_icon.classList.add("left-15");
    likes_icon.classList.add("color-primary");
    likes_icon.addEventListener("click",function(){likeThisProductInAll(this, "like")}, false);

    var dislikes_icon = document.createElement("i");
    //Comprobar si ya el usuario le dió dislike viendo las cookies
    if(user_liked && user_liked=="dislike"){
      dislikes_icon.classList.add("fas");
    }else{
      dislikes_icon.classList.add("far");
    }

    dislikes_icon.classList.add("fa-thumbs-down");
    dislikes_icon.classList.add("left-15");
    dislikes_icon.classList.add("color-primary");
    dislikes_icon.addEventListener("click",function(){likeThisProductInAll(this, "dislike")}, false);

    new_likes_dislikes_container.append(likes_icon);
    new_likes_dislikes_container.append(dislikes_icon);
    likes_icon.before(current_rev['likes']);


    new_username.append(new_comment_date);

    new_comment_info_1.append(new_img_country);
    new_comment_info_1.append(new_country_span);
    new_comment_info_1.append(new_rating_span);

    new_comment_text.append(new_username);
    new_comment_text.append(new_comment_info_1);
    new_comment_text.append(new_likes_dislikes_container);
    
    var paragraph_review = document.createElement('p');
    paragraph_review.classList.add('review-paragraph-big');
    paragraph_review.textContent = current_rev['comment'];
    
    new_likes_dislikes_container.before(paragraph_review);


    new_review.append(new_pic);
    new_review.append(new_comment_text);              

    $('#all_comments_container').append(new_review);

    $("#rating-star-new").rating({
      "value": current_rev['rating'],
      "color": "#f61",
      "readonly": true

    });
    $("#rating-star-new").removeAttr("id");
  });
  
};

window.pajpApp.copy_reviews_container = function(){

  var addtocart_selectors = ["#MainContent"];
      addtocart_selectors.forEach(function (selector) {
        var els = document.getElementById("MainContent");
        if (typeof els == "object" && els) {
          

            els.append(document.getElementById('pajp-reviews-automatic-code').children[0])

          
        }
      });
};

function readURL(input) {
  if (input.files && input.files[0]) {
    var reader = new FileReader();

    reader.onload = function (e) {
      $('#preview img').attr('src', e.target.result);
      //document.getElementById('img-set').value = e.target.result;
    }

    reader.readAsDataURL(input.files[0]);
  }
}

function cleanReviewsData(){
	$('#PajpReviewsContainer .pajp_reviews_rating').empty();
  	//$('#PajpReviewsContainer .card-comments').empty();
  	$('#last_reviews').empty();
  	//$('#all_comments_container').empty();
}

function cleanReviewsDataInAll(){
	//$('#PajpReviewsContainer .pajp_reviews_rating').empty();
  	//$('#PajpReviewsContainer .card-comments').empty();
  	$('#all_comments_container').empty();
}

function likeThisProduct(e, action){
  
  	var like_container = $(e).parent();
  
  	var user_liked = getCookie("review_liked_"+like_container.attr("review_id"));
  	//var user_disliked = getCookie("review_disliked_"+like_container.attr("review_id"));
  	//Comprobar si ya el usuario le dió like o dislike y mandarlo tambien al backend
  	//console.log(user_liked);
 
  	$.ajax({
      url: "https://pajphost.com/customer/public/api/likeDislikeReview",
      type: "post",
      data: {
        'review_id': like_container.attr("review_id"),
        'action': action,
        'user_liked': user_liked
        
      } ,
      success: function (response) {

        //console.log(response);
        //return false;
        if(response.operation == "add"){
        	document.cookie = "review_liked_"+response.review_id+"="+response.action+"; expires=Thu, 01 Jan 2100 00:00:00 UTC;";
        }else if(response.operation == "remove"){
        	document.cookie = "review_liked_"+response.review_id+"=; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
        }else{
        	document.cookie = "review_liked_"+response.review_id+"="+response.action+"; expires=Thu, 01 Jan 2100 00:00:00 UTC;";
        }
        cleanReviewsData();
        window.pajpApp.check_reviews();

        //cerrar el modal
        //document.getElementById("addReview").style.display = "none";

        //preguntar si hizo like o dislike para mostrar un mensaje u otro
        pajpApp.showToast("Review like/dislike success.", true);

      },
      error: function(jqXHR, textStatus, errorThrown) {
        console.log(textStatus, errorThrown);

        //show notification
        /*$(document).Toasts('create', {
                    class: 'bg-danger bring-top',
                    autohide: true,
                    delay: 9999,
                    title: 'Saving failed',
                    body: 'Please check all chart data and try again.'
                  });*/

        pajpApp.showToast("Review like/dislike failed.", true);
      }
    });
  
}

function likeThisProductInAll(e, action){
  
  	var like_container = $(e).parent();
  
  	var user_liked = getCookie("review_liked_"+like_container.attr("review_id"));
  	//var user_disliked = getCookie("review_disliked_"+like_container.attr("review_id"));
  	//Comprobar si ya el usuario le dió like o dislike y mandarlo tambien al backend
  	//console.log(user_liked);
 
  	$.ajax({
      url: "https://pajphost.com/customer/public/api/likeDislikeReview",
      type: "post",
      data: {
        'review_id': like_container.attr("review_id"),
        'action': action,
        'user_liked': user_liked
        
      } ,
      success: function (response) {

        //console.log(response);
        if(response.operation == "add"){
        	document.cookie = "review_liked_"+response.review_id+"="+response.action+"; expires=Thu, 01 Jan 2100 00:00:00 UTC;";
        }else if(response.operation == "remove"){
        	document.cookie = "review_liked_"+response.review_id+"=; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
        }else{
        	document.cookie = "review_liked_"+response.review_id+"="+response.action+"; expires=Thu, 01 Jan 2100 00:00:00 UTC;";
        }
        cleanReviewsData();
        
        window.pajpApp.check_reviews();
        
        setTimeout(function(){
          	cleanReviewsDataInAll();
        	window.pajpApp.fill_all_reviews_modal();
        }, 1000);

        //cerrar el modal
        //document.getElementById("addReview").style.display = "none";

        //preguntar si hizo like o dislike para mostrar un mensaje u otro
        pajpApp.showToast("Review like/dislike success.", true);

      },
      error: function(jqXHR, textStatus, errorThrown) {
        console.log(textStatus, errorThrown);

        //show notification
        /*$(document).Toasts('create', {
                    class: 'bg-danger bring-top',
                    autohide: true,
                    delay: 9999,
                    title: 'Saving failed',
                    body: 'Please check all chart data and try again.'
                  });*/

        pajpApp.showToast("Review like/dislike failed.", true);
      }
    });
  
}

function likeThisProductInMore(e, action){
  
  	var like_container = $(e).parent();
  
  	var user_liked = getCookie("review_liked_"+like_container.attr("review_id"));
  	//var user_disliked = getCookie("review_disliked_"+like_container.attr("review_id"));
  	//Comprobar si ya el usuario le dió like o dislike y mandarlo tambien al backend
  	//console.log(user_liked);
 
  	$.ajax({
      url: "https://pajphost.com/customer/public/api/likeDislikeReview",
      type: "post",
      data: {
        'review_id': like_container.attr("review_id"),
        'action': action,
        'user_liked': user_liked
        
      } ,
      success: function (response) {

        //console.log(response);
        if(response.operation == "add"){
        	document.cookie = "review_liked_"+response.review_id+"="+response.action+"; expires=Thu, 01 Jan 2100 00:00:00 UTC;";
        }else if(response.operation == "remove"){
        	document.cookie = "review_liked_"+response.review_id+"=; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
        }else{
        	document.cookie = "review_liked_"+response.review_id+"="+response.action+"; expires=Thu, 01 Jan 2100 00:00:00 UTC;";
        }
        cleanReviewsData();
        
        window.pajpApp.check_reviews();
        
        setTimeout(function(){
          //actualizar los likes y/ cambiar los iconos de like y dislike
          $('#seeMoreReview .like-count').text(response.like_count);
          	
          if(response.operation == "add"){
            if(response.action == "like"){
            	//colorear el icono de likes
              	$('#seeMoreReview .fa-thumbs-up').removeClass("far");
              	$('#seeMoreReview .fa-thumbs-up').addClass("fas");
            }else{
            	//colorear el icono de dislike
              	$('#seeMoreReview .fa-thumbs-down').removeClass("far");
              	$('#seeMoreReview .fa-thumbs-down').addClass("fas");
            }
          }else if(response.operation == "remove"){
              if(response.action == "like"){
            	//decolorear el icono de likes
                $('#seeMoreReview .fa-thumbs-up').removeClass("fas");
              	$('#seeMoreReview .fa-thumbs-up').addClass("far");
              }else{
                //decolorear el icono de dislike
                $('#seeMoreReview .fa-thumbs-down').removeClass("fas");
              	$('#seeMoreReview .fa-thumbs-down').addClass("far");
              }
          }else{
              if(response.action == "like"){
            	//colorear like y decolorear dislike
                $('#seeMoreReview .fa-thumbs-up').removeClass("far");
              	$('#seeMoreReview .fa-thumbs-up').addClass("fas");
                
                $('#seeMoreReview .fa-thumbs-down').removeClass("fas");
              	$('#seeMoreReview .fa-thumbs-down').addClass("far");
              }else{
                //colorear dislike y decolorear like
                $('#seeMoreReview .fa-thumbs-down').removeClass("far");
              	$('#seeMoreReview .fa-thumbs-down').addClass("fas");
                
                $('#seeMoreReview .fa-thumbs-up').removeClass("fas");
              	$('#seeMoreReview .fa-thumbs-up').addClass("far");
              }
          }
        }, 1000);

        //cerrar el modal
        //document.getElementById("addReview").style.display = "none";

        //preguntar si hizo like o dislike para mostrar un mensaje u otro
        pajpApp.showToast("Review like/dislike success.", true);

      },
      error: function(jqXHR, textStatus, errorThrown) {
        console.log(textStatus, errorThrown);

        //show notification
        /*$(document).Toasts('create', {
                    class: 'bg-danger bring-top',
                    autohide: true,
                    delay: 9999,
                    title: 'Saving failed',
                    body: 'Please check all chart data and try again.'
                  });*/

        pajpApp.showToast("Review like/dislike failed.", true);
      }
    });
  
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function submit_parent(e){
  var form_parent_submit = $(e).parent();
  //Aqui iria lo necesario para actualizar la cantidad de reviews, el promedio de rating, actualizar las estrellas por ese nuevo promedio
  //El ajax de crear un review tiene q devolver el nuevo promedio y la nueva cantidad
  //var grand_parent = $(e).parent().parent().parent().parent().parent().parent().parent();
  //var review_count_badge = grand_parent.find(".badge");
  
  //tengo q crear otro endpoint para la llamada desde el front

  var customer_id = form_parent_submit.find("#customer_id").val();
  var customer_pic = form_parent_submit.find("#customer_pic");
  var customer_name = form_parent_submit.find("#customer_name").val();
  var customer_country = form_parent_submit.find("#customer_country").val();
  var customer_birthdate = form_parent_submit.find("#customer_birthdate").val();
  var customer_gender = form_parent_submit.find("#customer_gender").val();
  var review_likes = 0;
  var review_dislikes = 0;
  var review_views = 0;
  var review_rating = form_parent_submit.find("#rating").val();
  var review_content = form_parent_submit.find("#review_content").val();

  var product_id = form_parent_submit.find("#product_id").val();
  var shop_id = form_parent_submit.find("#shop_id").val();
  
  var variant_id = $('#pajp-reviews-automatic-code').attr("data-pajp-variant-id");

  //se podría poner el default si no se va a usar las iniciales
  var pic_html_code = "";


  if(review_rating == 0){
  	pajpApp.showToast("Please enter an 1-5 review rating", true);

    return false;
  }
  if(customer_name == "" || review_content == ""){
    //notificacion de que faltan datos
    /*$(document).Toasts('create', {
      class: 'bg-danger bring-top',
      autohide: true,
      delay: 9999,
      title: 'Missing data',
      body: "Enter all review's data and save the form again."
    });*/
    
    pajpApp.showToast("Missing data. Enter all review's data and save the form again.", true);


    return false;
  }else{

    if(customer_pic.attr("type") != "hidden"){
     
    	//var file = customer_pic.prop("files")[0];
        if(false /*file*/){
          var fileExt = "";
          var fileName = customer_name.replaceAll(" ", "_");

          fileExt = file['name'].substr(file['name'].lastIndexOf('.') + 1);

          var form_data = new FormData();

          form_data.append('file', file);
          form_data.append('fileName', fileName);
          form_data.append('fileExt', fileExt);

          $.ajax({
            url: "https://pajphost.com/customer/public/api/upload_customer_image",
            type: 'post',
            data: form_data,
            contentType: false,
            processData: false,
            success: function(response){

              //console.log(response);
              //url de la imagen subida
              pic_html_code = response;

              $.ajax({
                url: "https://pajphost.com/customer/public/api/addReviewFront",
                type: "post",
                data: {
                  'pic': pic_html_code,
                  'name': customer_name,
                  'country': customer_country,
                  'likes': review_likes,
                  'dislikes': review_dislikes,
                  'views': review_views,
                  'rating': review_rating,
                  'content': review_content,
                  'product_id': product_id,
                  'variant_id': variant_id,
                  'shop_id': shop_id,
                  'customer_id': customer_id,
                  'customer_birthdate': customer_birthdate,
                  'customer_gender': customer_gender
                } ,
                success: function (response) {

                  //console.log(response);
                  cleanReviewsData();
                  window.pajpApp.check_reviews();

                  //cerrar el modal
                  document.getElementById("addReview").style.display = "none";
                  
                  pajpApp.showToast("Review successfuly created.", true);

                },
                error: function(jqXHR, textStatus, errorThrown) {
                  console.log(textStatus, errorThrown);

                  //show notification
                  /*$(document).Toasts('create', {
                    class: 'bg-danger bring-top',
                    autohide: true,
                    delay: 9999,
                    title: 'Saving failed',
                    body: 'Please check all chart data and try again.'
                  });*/
                  
                  pajpApp.showToast("Creating failed. Please check all review data and try again.", true);
                }
              });
            },
            error: function(responseError){
              console.log(responseError);
            }
          });
        }else{
          
          //hacer lo de las iniciales como foto del customer del review
          //Hacer llamada de ajax igual que la otra
          $.ajax({
                url: "https://pajphost.com/customer/public/api/addReviewFront",
                type: "post",
                data: {
                  'pic': "empty",
                  'name': customer_name,
                  'country': customer_country,
                  'likes': review_likes,
                  'dislikes': review_dislikes,
                  'views': review_views,
                  'rating': review_rating,
                  'content': review_content,
                  'product_id': product_id,
                  'variant_id': variant_id,
                  'shop_id': shop_id,
                  'customer_id': customer_id,
                  'customer_birthdate': customer_birthdate,
                  'customer_gender': customer_gender
                } ,
                success: function (response) {

                  //console.log(response);
                  cleanReviewsData();
                  window.pajpApp.check_reviews();

                  //cerrar el modal
                  document.getElementById("addReview").style.display = "none";
                  
                  pajpApp.showToast("Review successfuly created.", true);

                },
                error: function(jqXHR, textStatus, errorThrown) {
                  console.log(textStatus, errorThrown);

                  //show notification
                  /*$(document).Toasts('create', {
                    class: 'bg-danger bring-top',
                    autohide: true,
                    delay: 9999,
                    title: 'Saving failed',
                    body: 'Please check all chart data and try again.'
                  });*/
                  
                  pajpApp.showToast("Creating failed. Please check all review data and try again.", true);
                }
              });
        }
    }else{
    	//Customer logged
      	pic_html_code = customer_pic.val();
        $.ajax({
                  url: "https://pajphost.com/customer/public/api/addReviewFront",
                  type: "post",
                  data: {
                    'pic': pic_html_code,
                    'name': customer_name,
                    'country': customer_country,
                    'likes': review_likes,
                    'dislikes': review_dislikes,
                    'views': review_views,
                    'rating': review_rating,
                    'content': review_content,
                    'product_id': product_id,
                    'variant_id': variant_id,
                    'shop_id': shop_id,
                    'customer_id': customer_id,
                    'customer_birthdate': customer_birthdate,
                    'customer_gender': customer_gender
                  } ,
                  success: function (response) {

                    //console.log(response);
                    cleanReviewsData();
                    window.pajpApp.check_reviews();
                    
                    document.getElementById("addReview").style.display = "none";

                    
                    pajpApp.showToast("Review successfuly saved.", true);

                  },
                  error: function(jqXHR, textStatus, errorThrown) {
                    console.log(textStatus, errorThrown);

                    //show notification
                    /*$(document).Toasts('create', {
                      class: 'bg-danger bring-top',
                      autohide: true,
                      delay: 9999,
                      title: 'Saving failed',
                      body: 'Please check all chart data and try again.'
                    });*/
                    
                    pajpApp.showToast("Saving failed. Please check all review data and try again.", true);
                  }
                });
    }
    

  }
}

function edit_parent(e){
  var form_parent_submit = $(e).parent();

  var review_rating = form_parent_submit.find("#rating_edit").val();
  var review_content = form_parent_submit.find("#review_content_edit").val();
  var review_id = form_parent_submit.find("#review_id_edit").val();
  var shop_id = form_parent_submit.find("#shop_id_edit").val();

  if(review_content == ""){
    
    pajpApp.showToast("Missing content. Enter the review's content and save the form again.", true);


    return false;
  }else{

        $.ajax({
                  url: "https://pajphost.com/customer/public/api/editReviewFront",
                  type: "post",
                  data: {
                    'review_id': review_id,
                    'rating': review_rating,
                    'content': review_content,
                    'shop_id': shop_id
                  } ,
                  success: function (response) {

                    //console.log(response);
                    cleanReviewsData();
                    window.pajpApp.check_reviews();
                    
                    document.getElementById("editReview").style.display = "none";

                    
                    pajpApp.showToast("Review successfuly edited.", true);

                  },
                  error: function(jqXHR, textStatus, errorThrown) {
                    console.log(textStatus, errorThrown);
                    
                    pajpApp.showToast("Editing failed. Please check all review data and try again.", true);
                  }
                });
    }
    
}

window.pajpApp.showToast = function (text, auto) {
	// Get the snackbar DIV
    var x = document.getElementById("snackbar");
  	$(x).text(text);
    // Add the "show" class to DIV
    x.className = "show";

    if(auto){
		// After 3 seconds, remove the show class from DIV
    	setTimeout(function(){ x.className = x.className.replace("show", ""); }, 3000);
    }		
    
};

/*window.pajpApp.addCLickEventSizeBtn = function(){
  
	var sizes_btn = document.querySelector('.pajp_sizes_btn');
  
  	sizes_btn.addEventListener('click', function(e){
    	// Get the modal
		var modal = document.getElementById("layout_container");
      	// Get the <span> element that closes the modal
		var span = document.getElementById("closeModal");
      
      	modal.style.display = "block";
      
      	// When the user clicks on <span> (x), close the modal
        span.onclick = function() {
          modal.style.display = "none";
        }

        // When the user clicks anywhere outside of the modal, close it
        window.onclick = function(event) {
          if (event.target == modal) {
            modal.style.display = "none";
          }
        } 
    });
};*/